import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import { GET_ATYPELIST_GQL } from '@/graphql/queries.gql';

export default {
  namespaced: true,

  state: {
    usertypes: null,
  },

  mutations: {
    GET_ATYPE_LIST(state, payload) {
      state.usertypes = payload;
    },
  },

  actions: {
    // = methods
    // destructuring `context.commit` by doing `{ commit }`
    getaTypeList({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_ATYPELIST_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('GET_ATYPE_LIST', data.userTypes);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
  },

  getters: {
    // = computed properties
    usertypes: state => state.usertypes,
  },
};
